import React, { useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BalanceChart } from "../../Helpers";
let backendUrl = process.env.REACT_APP_BACKEND_URL;
let frontendUrl = process.env.REACT_APP_FRONTEND_URL;

function Dashboard() {
  let navigate = useNavigate();
  const [categories, setCategories] = useState(false);
  const rechargeOperator = async (name) => {
    if (name == "INDO-NEPAL Money Transfer") {
      navigate("/admin/indoNepalMoneyTransfer");
    }
    else if (name == "Money Transfer") {
      navigate("/admin/imeMoneyTransfer");
    }
    else if (name == "Kyc") {
      navigate("/admin/kycs");
    }
    else if (name == "Pargati Bazaar") {
      window.open(
        frontendUrl + '/bazaar',
        '_blank'
      );
    }
    else if (name == "Indian Recharge") {
      navigate("/admin/indianRecharge");
    }
    else {
      navigate("/admin/recharge");
    }
  };
  const getData = async () => {
    try {
      const response = await axios.get('/category/all');
      const { status, data } = response.data;
      if (status) {
        setCategories(data);
      }
    }
    catch (error) {
      if (error?.response?.data?.message) {
        toast(error.response.data.message);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div class="content-wrapper">
      <div class="row">
        <div class="col-md-12 grid-margin">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h4 class="font-weight-bold mb-0">Dashboard</h4>
            </div>
            <div>
              <button type="button" class="btn btn-primary btn-icon-text btn-rounded" onClick={() => navigate("/admin/addMoney")}>
                <i class="ti-clipboard btn-icon-prepend"></i>Add Money
              </button>
            </div>
          </div>
        </div>
      </div>
      <BalanceChart />
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
          <div class="card position-relative">
            <div class="card-body">
              <div class="row recharge">
                {
                  categories && categories.map((item, index) => (
                    <div class="col-lg-2 col-md-4 col-sm-6" onClick={(e) => rechargeOperator(item.category_name)}>
                      <img src={`${backendUrl}/${item.image}`} />
                      <div>{item.category_name}</div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
